import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDeal } from '../../deals/interfaces';
import { fetchDealsList } from './dealsList.thunk';

interface IDealsListState {
  loading: boolean;
  deals: IDeal[];
}

export const initialState: IDealsListState = {
  loading: false,
  deals: []
};

const dealsListSlice = createSlice({
  name: 'dealsList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDealsList.pending, (state: IDealsListState) => {
      state.loading = true;
    });
    builder.addCase(fetchDealsList.fulfilled, (state: IDealsListState, action: PayloadAction<IDeal[]>) => {
      state.loading = false;
      state.deals = [...action.payload];
    });
    builder.addCase(fetchDealsList.rejected, (state: IDealsListState) => {
      state.loading = false;
    });
  }
});

export const dealsListReducer = dealsListSlice.reducer;
